// Copyright (c) 2019-22 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';
import ImportFileProvider from './FileProvider';
import '../../../styles/import.css';
import api from '../../../api';

const SCRIPT_TEMPLATE = "# node = {\n#     \"createdOn\": \"date\",\n#     \"dav_uri\": \"path\",\n#     \"link_uri\": \"link to page\",\n#     \"modifiedOn\": \"Data\",\n#     \"name\": \"Name of the item\",\n#     \"nodeType\": \"type of item\",\n#     \"uri\": \"Path\",\n#     \"your_permissions\": \"Number\"\n# }\n\n# View documentation here: https://developer.smartvault.com/api\n\ndef run(node): \n    return True";

class ImportShareFile extends ImportFileProvider {
    // State from ImportFileProvider 
    // state = {
    //     authenticated, 
    //     configurations,
    //     config, 
    //     edit, 
    //     oauth, 
    //     folders, 
    //     expanded,
    //     stacks,
    //     template,
    // }

    state = {
        ...this.state,
        domain: "", 
    }

    scriptTemplate = SCRIPT_TEMPLATE; 

    loadConfig = async() => {
        const { connectionIdx } = this.props.data; 
        const config = this.props.team?.sync?.sharefile[connectionIdx] || {
            oauth: "",
            domain: "",
            configurations: [],
            authenticated: false,
        }

        this.setState({
            ...config, 
            configurations: config.folders || [],
            authenticated: false, 
            scriptTemplate: SCRIPT_TEMPLATE, 
        });
    }

    authenticate = async() => {
        const { code, subdomain, apicp } = this.props.data; 
        let oauthId = this.state.oauth; 

        // Do we already have oauth? 
        if(this.state.oauth) {
            const res = await api.get('/sync/sharefile/refresh?oauth=' + this.state.oauth);
            if(!res?.success??false)
                return toast.error("Unable to refresh the ShareFile connection");
        }

        // Do we have a code and a subdomain? We just went through the auth process... 
        if(code && subdomain && apicp) {    
            const res = await api.post("/sync/sharefile/token", {
                code, 
                domain: `${subdomain}.${apicp}`, 
            });

            if(!res || !res.oauthId)
                return toast.error("Unable to get a secure token from the ShareFile API"); 

            oauthId = res.oauthId;
        }

        this.setState({
            authenticated: true, 
            oauth: oauthId,
            ...(code && subdomain && apicp? {domain: `${subdomain}.${apicp}`}: {})
        });

        // Do we need to save this config?  
        if(code && subdomain && apicp)
            await this.saveConfig();
    }

    loadRoot = async() => {
        this.setState({ loading: true });
        const {folders} = await this.listFolders();
        this.setState({
            folders,
            loading: false
        });
    }


    listFolders = async(folder) => {

        // Are we authenticated? 
        if(!this.state.authenticated)
            return { folders: [] };  

        const res = await api.post("/sync/sharefile/list", {
            ...(folder? { folder: folder.id } : {}),
            oauth: this.state.oauth,
        });

        const folders = res?.items?.filter(i => i.type === 'folder').map((item) => {
            const itemInfo = {
                name: item.name, 
                path: this.removeFirstSlash(folder?.path? folder.path + "/" + item.name : item.name),
                path_display: this.removeFirstSlash(folder?.path? folder.path + "/" + item.name : item.name),
                _id: item.id, 
                id: item.id,   
            }
            return {
                ...itemInfo,
                loadChildren: async() => {
                    const children = await this.listFolders(itemInfo);
                    this.loading = false; 
                    this.loaded = true; 
                    this.setState({folders: [...this.state.folders, ...children.folders]});
                }
            }
        })

        return { folders }
    }

    saveConfig = async() => {
        const sync = this.props.team?.sync?? {}; 
        const connections = sync?.sharefile??[];

        const connectionIdx = this.props.data?.connectionIdx ?? connections.length; 
        
        const connection = {
            user: this.props.user._id, 
            oauth: this.state.oauth,
            domain: this.state.domain,
            ...(connections[connectionIdx] || {}),
            folders: this.state.configurations,
        };

        connections.push(connection);
        
        sync.sharefile = connections;

        await this.props.updateTeam({sync});
    }

    renderContent = () => {
        return (
            <>
                {this.renderConfigEditor()}
            </>
        )
    }

    renderDescription = () => {
        return(
            <div>
                <h1>Sync documents from ShareFile</h1>

                <p>
                    Stax·ai will make stacks for each ShareFile folder you select below and mirror the contents of these folders into your new stacks.
                </p>
            </div>
        )
    }    
}

export default withRouter(ImportShareFile);
